import React from "react";
import { TextInput, required, ReferenceArrayInput, SelectInput, usePermissions, ReferenceInput, AutocompleteInput } from 'react-admin';
import { useFormState } from 'react-final-form';

import { GridForm, GridInput } from '../../../components/GridForm';
import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import { UserRole } from "entities/UserRole";
import { isInArray } from "utils/general";
import { UserType } from "entities/UserType";

import { FormSchemaInput } from "./FormSchemaInput";


const tokenEndpointAuthMethodChoices = [
	{id: "none", name: "none"},
	{id: "client_secret_basic", name: "client_secret_basic"},
	{id: "client_secret_post", name: "client_secret_post"},
];
const grantTypesChoices = [
	{id: "authorization_code", name: "authorization_code"},
	{id: "client_credentials", name: "client_credentials"},
	{id: "refresh_token", name: "refresh_token"},
];
const responseTypesChoices = [
	{id: "code", name: "code"},
];

export const ThirdPartyAppForm = ({ isAddForm = false, ...props }) => {
	const { permissions } = usePermissions();
	const { values } = useFormState();

	if (!permissions) return null;

	const isDisabledMode = !isAddForm;
	const isDeveloper = permissions.role === UserRole.developer;

	let permittedGrantTypesChoices = grantTypesChoices;
	if (isDeveloper) {
		if (!(
			isInArray(props?.record?.["grant_types"] ?? [], "client_credentials") ||
			isInArray(values?.["grant_types"] ?? [], "client_credentials")
		)) {
			permittedGrantTypesChoices = grantTypesChoices.filter((item) => item.id !== "client_credentials");
		}
	}

	return (
		<GridForm {...props}>
			<GridInput xs={12} component={TextInput} validate={required()} source="client_name" autoFocus disabled={isDisabledMode} />
			<GridInput xs={12} sm={6} component={SelectInput} validate={required()} source="token_endpoint_auth_method" 
				choices={tokenEndpointAuthMethodChoices} disabled={isDisabledMode} />
			<GridInput xs={12} sm={6} component={TextInput} validate={required()} source="redirect_uri" disabled={isDisabledMode} />
			<GridInput xs={12} sm={6} component={TextInput} source="disconnect_url" />
			<GridInput xs={12} sm={6} component={TextInput} source="connect_url" />
			<GridInput xs={12} sm={6} component={AutocompleteArrayInputEx} validate={required()} 
				source="grant_types" choices={permittedGrantTypesChoices} />
			<GridInput xs={12} sm={6} component={AutocompleteArrayInputEx} validate={required()}
				source="response_types" choices={responseTypesChoices} disabled={isDisabledMode} />
			<GridInput xs={12} sm={6} options={{size: "small"}} validate={required()} disabled={isDisabledMode}>
				<ReferenceArrayInput
					source="scope"
					reference="oauth2-available-scopes"
					filter={{ no_range: true }}
				>
					<AutocompleteArrayInputEx optionText="name" />
				</ReferenceArrayInput>
			</GridInput>
			{!isDeveloper ?
				<GridInput xs={12} sm={6} options={{size: "small"}} validate={required()} disabled={isDisabledMode}>
					<ReferenceInput
						source="user_id"
						reference="developers"
						perPage={15}
						filter={{
							no_range: false,
							is_blocked: false,
							is_deleted: false,
						}}
					>
						<AutocompleteInput
							optionText={(r) => (r ? `${r.first_name} ${r.last_name}` : null)}
							resettable
						/>
					</ReferenceInput>
				</GridInput>
			: null}
			<GridInput xs={12}>
				<FormSchemaInput />
			</GridInput>
		</GridForm>
	);
};